import PropTypes from "prop-types"
import React, { Component } from "react"

export default class PageHeader extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
  }

  render() {
    const { className, children } = this.props
    return <div className={`common-page-header ${className}`}>{children}</div>
  }
}



// WEBPACK FOOTER //
// ./src/features/common/PageHeader.js